const findTeam =
    (teamId, teams) =>
        (teams || []).find(team => team.id === teamId)

const groupTagsByTeam = (tags, allTags) => {
    const teamTagsMap =  tags.reduce( (acc, t) => {
        const tag = allTags[t]
        if (!tag) {
            return acc
        }

        return {
            ...acc,
            [tag.teamId]: [...(acc[tag.teamId] || []), tag],
        }
    }, {})

    // for each value in the team -> tag array map ...
    Object.values(teamTagsMap)
        .forEach( tags => tags.sort(
            // ... sort tags array by name
            (a, b) =>a.name == b.name ? 0 : a.name > b.name ? 1 : -1 )
        )

    return teamTagsMap
}

export {
    findTeam,
    groupTagsByTeam,
}


// WEBPACK FOOTER //
// ./src/common/components/time_row.js